<template>
  <div class="event-child">
    <div class="event-content" v-html="content" v-if="typeof content === 'string'"></div>
    <Content class="event-content" :content="content" v-else ></Content>
  </div>
</template>

<script>
import Content from '@/components/Utils/Content.vue'

export default {
  name: 'ElectionSection',

  components: { Content },

  computed: {
    election () {
      return this.$store.getters.election
    },

    title () {
      let title = ''

      switch (this.$route.name) {
        case 'election-candidates':
          title = 'Кандидати'
          break

        case 'election-rules':
          title = 'Правила'
          break
      }

      return title
    },

    content () {
      let content = ''

      switch (this.$route.name) {
        case 'election-candidates':
          content = this.election.candidates_new && this.election.candidates_new.content
            ? this.election.candidates_new.content : this.election.candidates
          break

        case 'election-rules':
          content = this.election.rules
          break
      }

      return content
    }
  }
}
</script>
